import { useCallback } from "react";

export const useClarityEventTracking = () => {
  const trackEvent = useCallback((eventName) => {
    if (window.clarity && eventName) {
      window.clarity("event", eventName);
    }
  }, []);

  return trackEvent;
};
